module.exports = __webpack_public_path__ + "static/Moret-c1273cc71043e3d5cdbc404c83e972e5.woff";